export interface AllocationColorThreshold {
  threshold: number
  color: string
}

export const ALLOCATION_COLOR_THRESHOLDS: AllocationColorThreshold[] = [
  { threshold: 0.5, color: '#662506' },
  { threshold: 0.2, color: '#993404' },
  { threshold: 0.1, color: '#d95f0e' },
  { threshold: 0.05, color: '#fec44f' },
  { threshold: 0.02, color: '#fee391' },
  { threshold: 0, color: '#fff7bc' }
]

export const getColorForAllocation = (allocation: number): string => {
  for (const { threshold, color } of ALLOCATION_COLOR_THRESHOLDS) {
    if (allocation >= threshold) {
      return color
    }
  }
  return ALLOCATION_COLOR_THRESHOLDS[ALLOCATION_COLOR_THRESHOLDS.length - 1].color
}

export const buildMapboxCaseExpression = (property: string = 'allocation_sum'): any => {
  const caseExpression: any[] = ['case']

  for (const { threshold, color } of ALLOCATION_COLOR_THRESHOLDS.slice(0, -1)) {
    caseExpression.push(['>=', ['get', property], threshold])
    caseExpression.push(color)
  }

  caseExpression.push(ALLOCATION_COLOR_THRESHOLDS[ALLOCATION_COLOR_THRESHOLDS.length - 1].color)

  return caseExpression
}
